/* eslint-disable import/prefer-default-export */
export function getSelectedSeller() {
    if (localStorage && localStorage.seller) {
        return JSON.parse(localStorage.seller);
    }

    return null;
}
